import React from 'react';
import { AcceptedProps } from '../../../object/interface/accepted-props';
import SingleLine from './single';

const LineType: React.FC<AcceptedProps> = (props) => {
  return <SingleLine {...props} />
}

export default LineType;